module.exports = __webpack_public_path__ + "static/hello-b8705e1e6d4170b7fcd7d10fc2b6eb17.png";